import React, { Component } from 'react'
import { Layout } from 'antd';
import '../../../App.css'
import './index.css'
import SideBox from '../../cell/Side'
import { withTranslation } from 'react-i18next';
const { Content, Sider } = Layout;
let Area ;
//台湾:es-ygj.digiwincloud.com
if(window.location.host === 'es-ygj.digiwincloud.com'){
    Area = true
}else{
    Area = false
}
const users = {
    continentService: [
        {
            apartment:'Workflow ERP 產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(04)2305-7272'
                },
                {
                    apart:'桃園',
                    tel:'(03)336-9070'
                },
                {
                    apart:'新竹',
                    tel:'(03)515-3223'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-7272'
                },
                {
                    apart:'台南',
                    tel:'(06)228-0658'
                },
                {
                    apart:'高雄',
                    tel:'(07)390-0242'
                },
                {
                    apart:'越南',
                    tel:'84-8-37700788'
                }
            ]
        },
        {
            apartment:'Smart ERP 產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(02)8911-1480'
                },
                {
                    apart:'桃園',
                    tel:'(03)336-9082'
                },
                {
                    apart:'新竹',
                    tel:'(03)515-3196'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-1511'
                },
                {
                    apart:'台南',
                    tel:'(06)228-0718'
                },
                {
                    apart:'高雄',
                    tel:'(07)390-0121'
                },
            ]

        },{
            apartment:'超級特助/e-GO/雲端B2 產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(02)8911-0168'
                },
                {
                    apart:'桃園',
                    tel:'(03)336-9399'
                },
                {
                    apart:'新竹',
                    tel:'(03)515-3190'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-1533'
                },
                {
                    apart:'台南',
                    tel:'(06)228-1956'
                },
                {
                    apart:'高雄',
                    tel:'(07)390-0185'
                },
            ]
        },{
            apartment:'Cosmos ERP及POS 產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(02)8911-0268'
                },
                {
                    apart:'桃園',
                    tel:'(02)8911-0268'
                },
                {
                    apart:'新竹',
                    tel:'(03)534-5606'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-1363'
                },
                {
                    apart:'台南',
                    tel:'(06)228-1886'
                },
                {
                    apart:'高雄',
                    tel:'(07)395-7860'
                },
            ]
        },{
            apartment:'TIPTOP ERP 產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(02)8911-0468'
                },
                {
                    apart:'桃園',
                    tel:'(02)8911-0468'
                },
                {
                    apart:'新竹',
                    tel:'(03)534-2035'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-1386'
                },
                {
                    apart:'台南',
                    tel:'(06)228-0656'
                }
            ]
        },{
            apartment:'ERPII (HRM/CRM/EasyFlow...)產品客服中心',
            list:[
                {
                    apart:'台北',
                    tel:'(02)8911-1988'
                },
                {
                    apart:'桃園',
                    tel:'(03)336-9062'
                },
                {
                    apart:'新竹',
                    tel:'(03)534-2038'
                },
                {
                    apart:'台中',
                    tel:'(04)2305-1370'
                },
                {
                    apart:'台南',
                    tel:'(06)228-0216'
                },{
                    apart:'高雄',
                    tel:'(07)395-8592'
                }
            ]
        },{
            apartment:'E10 ERP 產品客服中心專線',
            list:[
                {
                    apart:'全省',
                    tel:'(04)2305-0706'
                },
            ]
        }
    ],
    dlContinentService:[
        {
            apartment:'全国免费电话',
            list:[
                {
                    apart:'大陆',
                    tel:'400-626-5858'
                },
            ]
        }
        // {
        //     apartment:'技术支持中心',
        //     list:[
        //         {
        //             apart:'联系电话',
        //             tel:'15150501026'
        //         },
        //         {
        //             apart:'固定电话',
        //             tel:'025-68522756'
        //         },
        //         {
        //             apart:'邮箱',
        //             tel:'dukun@digiwin.com'
        //         },

        //     ]
        // }
    ]
}
const list = [];
class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this)
    }
    handleClick() {
        this.props.history.push({ pathname: "/contactUs" })
    }
    render() {
        const { t } = this.props;
        return (
            <Content className="q-content-wrapper">
                <div className="q-main" style={{ padding: '65px' }}>
                    <div className="q-fix-width ">
                        <Layout>
                            <Content className="q-detail-content q-content-border q-padding-50">
                                <div className="q-contact-box">
                                    <h3>{t('dl_tel')}</h3>
                                    <div className="q-contact-box_list clear">
                                        <ul className="q-contact-box_item" >
                                            {
                                                (Area ? users.continentService:users.dlContinentService).map(item => {
                                                    return (
                                                        <li key={Math.random()*10000}>
                                                            <div className="contactHeader">{item.apartment}</div>
                                                            {
                                                                item.list.map(_item=>{
                                                                    return <div className="contactHeader-item" key={Math.random()*1000}><span>{_item.apart}：</span><span>{_item.tel}</span></div>
                                                                })  
                                                            }
                                                            
                                                        </li>
                                                    )
                                                })
                                                
                                            }
                                         </ul>
                                    </div>
                                </div>
                            </Content>
                            <Sider theme="light" className="q-detail-sider">
                            <SideBox type={Area ? '':'2'}/>
                            </Sider>
                        </Layout>
                    </div>
                </div>
            </Content>
        )
    }
}
export default withTranslation()(ContactUs)